import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import LayoutContainer from './index';
import { getLocalStorage } from '../../helpers/utils';

const PortalLayout = () => {
  useEffect(() => {
    const token = getLocalStorage('userAccessToken');
    if (!token && !['/property-info', '/add-new-property']?.includes(window?.location?.pathname)) {
      if (window?.location?.pathname === '/add-new-property') {
        window.location.pathname = '/add-new-property';
      } else {
        window.location.pathname = '/property-info';
      }
    }
  }, []);

  return (
    <LayoutContainer>
      <Outlet />
    </LayoutContainer>
  );
};

export default PortalLayout;
